require("./bootstrap");

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": document.head.querySelector(
                'meta[name="csrf-token"]'
            ),
        },
    });

    // Menu
    $(".nav-icon-container").on("click", function() {
        $("header").toggleClass("nav-open");

        if ($("header").hasClass("nav-open")) {
            $("body").css("overflow", "hidden");
        } else {
            $("body").css("overflow", "unset");
        }
    });

    $("#slider-content").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: "linear",
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {},
            },
        ],
    });

    $(".gallery")
        .imagesLoaded()
        .always(function(instance) {
            $(".gallery").masonry({
                itemSelector: ".gallery-img",
                gutter: ".gutter-sizer",
                horizontalOrder: true,
                percentPosition: true,
                columnWidth: ".gallery-img",
            });
        });

    $("#testimonials").slick({
        // slide: "div",
        arrows: true,
        pauseOnHover: true,
        swipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".scroll-to-services").on("click", function() {
        if ($("header").hasClass("nav-open")) {
            $("header").removeClass("nav-open");
            $("body").css("overflow", "unset");
        }

        $("html, body").animate(
            {
                scrollTop: $("#services").offset().top - 100,
            },
            1000
        );
    });

    // Positive message timeout
    setTimeout(function() {
        $(".message.positive").animate(
            {
                height: "toggle",
                opacity: "toggle",
            },
            500
        );
    }, 5000);

    // Convert .svg image to SVG format (add class="svg")
    $("img.svg").each(function() {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");

        $.get(
            imgURL,
            function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find("svg");

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== "undefined") {
                    $svg = $svg.attr("id", imgID);
                }

                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== "undefined") {
                    $svg = $svg.attr("class", imgClass + " replaced-svg");
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr("xmlns:a");

                // Replace image with new SVG
                $img.replaceWith($svg);
            },
            "xml"
        );
    });
});

$(window).on("load", function() {
    $(".loader").fadeOut("slow");
});

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisURL, "/", 2)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("?") == -1 ? thisURL.length : thisURL.indexOf("?")
        );
        thisURL = thisURL.substring(0, getPosition(thisURL, "/", 2));
        url = thisURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisSubURL, "/", 3)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("?") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("?")
        );
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, "/", 3));
        url = thisSubURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js